<template>
  <div class="bc-wrap">
    <div class="bc-toolbar no-print">
      <div class="bc-actions">
        <label class="bc-check">
          <input type="checkbox" v-model="price"> {{$t('Нарх')}}
        </label>
        <label class="bc-check">
          <input type="checkbox" v-model="showName"> {{$t('Товар')}}
        </label>
        <select class="form-control bc-size" v-model="labelSize">
          <option value="58x40">58 x 40 mm</option>
          <option value="50x30">50 x 30 mm</option>
          <option value="40x30">40 x 30 mm</option>
          <option value="40x25">40 x 25 mm</option>
          <option value="30x20">30 x 20 mm</option>
        </select>
        <button type="button" class="btn btn-success" @click="Clear">
          {{$t('Тозалаш')}}
        </button>
        <button type="button" class="btn btn-primary" @click="Print">
          <b-icon icon="printer"></b-icon> {{$t('Чоп этиш')}}
        </button>
      </div>
    </div>

    <table class="table table-bordered no-print">
      <thead>
        <tr>
          <th>{{$t('Товар')}}</th>
          <th>{{$t('Нарх')}}</th>
          <th>{{$t('Cони')}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in datas.prixod_table" :key="index">
          <td>{{ item.product ? item.product.extra_name : '' }}</td>
          <td>{{ item.chakana_price }}</td>
          <td>
            <input type="number" min="0" @input="item.count = parseInt(item.count) || 0" v-model="item.count">
          </td>
        </tr>
      </tbody>
    </table>

    <div class="print-area" id="print-area" :data-size="labelSize">
      <template v-for="(item, index) in datas.prixod_table">
        <template v-if="item.shtrix_kod && item.count > 0">
          <div
            v-for="n in parseInt(item.count)"
            :key="'bc-' + index + '-' + n"
            class="bc-page"
          >
            <div class="bc-name" v-if="showName && item.product">{{ item.product.extra_name }}</div>
            <div class="bc-price" v-if="price">
              <b>{{ item.chakana_price | numFormat0 }}</b> <span>сўм</span>
            </div>
            <div class="bc-barcode">
              <barcode
                :value="String(item.shtrix_kod)"
                :options="barcodeOptions"
                tag="svg"
              ></barcode>
            </div>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import VueBarcode from 'vue-barcode';
export default {
  name: "KirimBarcode",
  components: { 'barcode': VueBarcode },
  data() {
    return {
      datas: { prixod_table: [] },
      price: true,
      showName: true,
      labelSize: "58x40"
    };
  },
  computed: {
    barcodeOptions() {
      const map = {
        "58x40": { height: 30, width: 1.4, fontSize: 11 },
        "50x30": { height: 22, width: 1.2, fontSize: 10 },
        "40x30": { height: 20, width: 1, fontSize: 9 },
        "40x25": { height: 16, width: 1, fontSize: 8 },
        "30x20": { height: 12, width: 0.8, fontSize: 7 }
      };
      const s = map[this.labelSize] || map["58x40"];
      return {
        displayValue: true,
        fontSize: s.fontSize,
        height: s.height,
        width: s.width,
        margin: 0,
        textMargin: 1
      };
    }
  },
  created() {
    this.Data();
  },
  methods: {
    Data() {
      let self = this;
      axios.get("api/v1/prixod/id/" + self.$route.params.id).then(function (response) {
        self.datas = response.data;
      });
    },
    Clear() {
      this.datas.prixod_table.forEach(function (row) {
        row.count = 0;
      });
    },
    Print() {
      this.injectPageSize();
      this.$nextTick(() => window.print());
    },
    injectPageSize() {
      const sizes = {
        "58x40": "58mm 40mm",
        "50x30": "50mm 30mm",
        "40x30": "40mm 30mm",
        "40x25": "40mm 25mm",
        "30x20": "30mm 20mm"
      };
      const size = sizes[this.labelSize] || sizes["58x40"];
      let styleEl = document.getElementById("bc-page-size");
      if (!styleEl) {
        styleEl = document.createElement("style");
        styleEl.id = "bc-page-size";
        document.head.appendChild(styleEl);
      }
      styleEl.innerHTML = `@media print { @page { size: ${size}; margin: 0; } }`;
    }
  },
  watch: {
    labelSize: {
      immediate: true,
      handler() { this.injectPageSize(); }
    }
  },
  beforeDestroy() {
    const el = document.getElementById("bc-page-size");
    if (el) el.remove();
  }
};
</script>

<style scoped>
.bc-wrap {
  padding: 12px;
}
.bc-toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
.bc-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.bc-actions .btn {
  padding: 6px 14px;
  border-radius: 8px;
  font-weight: 600;
}
.bc-actions .bc-size {
  width: auto;
  min-width: 130px;
}
.bc-check {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-weight: 600;
}

.print-area {
  display: none;
}

.bc-page {
  page-break-after: always;
  page-break-inside: avoid;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  overflow: hidden;
}
.bc-page:last-child {
  page-break-after: auto;
}
.bc-name {
  font-weight: 700;
  line-height: 1.05;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.bc-barcode {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.bc-barcode svg {
  display: block;
  max-width: 100%;
  height: auto;
}
.bc-price {
  font-weight: 800;
  line-height: 1;
}
.bc-price span {
  font-weight: 600;
}

@media print {
  html, body {
    margin: 0 !important;
    padding: 0 !important;
    background: white !important;
  }
  .no-print {
    display: none !important;
  }
  .bc-wrap {
    padding: 0;
  }
  .print-area {
    display: block;
  }
  .bc-page {
    margin: 0;
    padding: 0.5mm;
  }

  /* 58 x 40 mm */
  .print-area[data-size="58x40"] .bc-page {
    width: 58mm; height: 40mm;
  }
  .print-area[data-size="58x40"] .bc-name { font-size: 16pt; margin-bottom: 0.5mm; }
  .print-area[data-size="58x40"] .bc-price { font-size: 24pt; margin-top: 0.5mm; }
  .print-area[data-size="58x40"] .bc-price span { font-size: 12pt; }
  .print-area[data-size="58x40"] .bc-barcode svg { max-height: 14mm; }

  /* 50 x 30 mm */
  .print-area[data-size="50x30"] .bc-page {
    width: 50mm; height: 30mm;
  }
  .print-area[data-size="50x30"] .bc-name { font-size: 14pt; margin-bottom: 0.3mm; }
  .print-area[data-size="50x30"] .bc-price { font-size: 18pt; margin-top: 0.3mm; }
  .print-area[data-size="50x30"] .bc-price span { font-size: 10pt; }
  .print-area[data-size="50x30"] .bc-barcode svg { max-height: 9mm; }

  /* 40 x 30 mm */
  .print-area[data-size="40x30"] .bc-page {
    width: 40mm; height: 30mm;
  }
  .print-area[data-size="40x30"] .bc-name { font-size: 12pt; margin-bottom: 0.3mm; }
  .print-area[data-size="40x30"] .bc-price { font-size: 16pt; margin-top: 0.3mm; }
  .print-area[data-size="40x30"] .bc-price span { font-size: 9pt; }
  .print-area[data-size="40x30"] .bc-barcode svg { max-height: 8mm; }

  /* 40 x 25 mm */
  .print-area[data-size="40x25"] .bc-page {
    width: 40mm; height: 25mm;
  }
  .print-area[data-size="40x25"] .bc-name { font-size: 12pt; margin-bottom: 0.2mm; -webkit-line-clamp: 1; line-clamp: 1; }
  .print-area[data-size="40x25"] .bc-price { font-size: 14pt; margin-top: 0.2mm; }
  .print-area[data-size="40x25"] .bc-price span { font-size: 8pt; }
  .print-area[data-size="40x25"] .bc-barcode svg { max-height: 6mm; }

  /* 30 x 20 mm */
  .print-area[data-size="30x20"] .bc-page {
    width: 30mm; height: 20mm;
    padding: 0.3mm;
  }
  .print-area[data-size="30x20"] .bc-name { font-size: 10pt; margin-bottom: 0.2mm; -webkit-line-clamp: 1; line-clamp: 1; }
  .print-area[data-size="30x20"] .bc-price { font-size: 12pt; margin-top: 0.2mm; }
  .print-area[data-size="30x20"] .bc-price span { font-size: 7pt; }
  .print-area[data-size="30x20"] .bc-barcode svg { max-height: 5mm; }
}

@media print {
  @page { size: auto; margin: 0; }
}
</style>
